import i18n from '@/main';

export function configureDrawLocal () {
    L.drawLocal = {
        draw: {
            toolbar: {
                actions: {
                    title: i18n?.t('mensagens.comuns.cancelar'),
                    text: i18n?.t('mensagens.comuns.cancelar')
                },
                finish: {
                    title: i18n?.t('mensagens.comuns.finalizar'),
                    text: i18n?.t('mensagens.comuns.finalizar')
                },
                undo: {
                    title: i18n?.t('mensagens.menuMapa.deletarUltimoPonto'),
                    text: i18n?.t('mensagens.menuMapa.deletarUltimoPonto')
                },
                buttons: {
                    polyline: '- your text-',
                    polygon: i18n?.t('mensagens.menuMapa.desenharPoligono'),
                    rectangle: '- your text-',
                    circle: '- your text-',
                    marker: '- your text-',
                    circlemarker: '- your text-'
                }
            },
            handlers: {
                circle: {
                    tooltip: {
                        start: '- your text-'
                    },
                    radius: '- your text-'
                },
                circlemarker: {
                    tooltip: {
                        start: '- your text-.'
                    }
                },
                marker: {
                    tooltip: {
                        start: i18n?.t('mensagens.menuMapa.clique.inserirMarcador')
                    }
                },
                polygon: {
                    tooltip: {
                        start: i18n?.t('mensagens.menuMapa.cliqueParaDesenharPoligono'),
                        cont: i18n?.t('mensagens.menuMapa.cliqueParaContinuarDesenhando'),
                        end: i18n?.t('mensagens.menuMapa.cliquePrimeiroPontoParaTerminar')
                    }
                },
                polyline: {
                    error: '<strong>Error:</strong> shape edges cannot cross!',
                    tooltip: {
                        start: 'Click to start drawing line.',
                        cont: 'Click to continue drawing line.',
                        end: 'Click last point to finish line.'
                    }
                },
                rectangle: {
                    tooltip: {
                        start: '- your text-.'
                    }
                },
                simpleshape: {
                    tooltip: {
                        end: 'Release mouse to finish drawing.'
                    }
                }
            }
        },
        edit: {
            toolbar: {
                actions: {
                    save: {
                        title: i18n?.t('mensagens.comuns.salvarAlteracoes'),
                        text: i18n?.t('mensagens.comuns.salvar')
                    },
                    cancel: {
                        title: i18n?.t('mensagens.menuMapa.cancelarEdicao'),
                        text: i18n?.t('mensagens.comuns.cancelar')
                    },
                    clearAll: {
                        title: i18n?.t('mensagens.menuMapa.removerTodosDesenhos'),
                        text: i18n?.t('mensagens.menuMapa.removerTodos')
                    }
                },
                buttons: {
                    edit: i18n?.t('mensagens.menuMapa.editarDesenho'),
                    editDisabled: i18n?.t('mensagens.menuMapa.naoExistemDesenhosParaEditar'),
                    remove: i18n?.t('mensagens.menuMapa.removerDesenhos'),
                    removeDisabled: i18n?.t('mensagens.menuMapa.naoExistemDesenhosParaRemover')
                }
            },
            handlers: {
                edit: {
                    tooltip: {
                        text: i18n?.t('mensagens.menuMapa.arrasteMarcadoresParaEditar'),
                        subtext: i18n?.t('mensagens.menuMapa.cancelarParaDesfazerAlteracoes')
                    }
                },
                remove: {
                    tooltip: {
                        text: i18n?.t('mensagens.menuMapa.cliqueEmUmDesenhoParaRemover')
                    }
                }
            }
        }
    };

    L.Edit.PolyVerticesEdit = L.Edit.PolyVerticesEdit.extend({
        options: {
            icon: new L.DivIcon({
                iconSize: new L.Point(10, 10),
                className:
                    'leaflet-div-icon leaflet-editing-icon leaflet-touch-icon'
            }),
            touchIcon: new L.DivIcon({
                iconSize: new L.Point(10, 10),
                className:
                    'leaflet-div-icon leaflet-editing-icon leaflet-touch-icon'
            })
        }
    });
};
